import React from "react";

const Home = () =>{
  return <>
    <h3>Homepage</h3>
  </>
}

export default Home